import React from 'react';

export default function Check(props) {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill={props.color || "#000000"}
                stroke="none"
            >
                <path
                    d="M1670 4784 c-36 -7 -107 -34 -157 -59 -207 -102 -345 -308 -360 -535
-5 -77 -3 -87 16 -107 15 -16 33 -23 60 -23 54 0 71 24 82 112 11 101 32 165
77 234 177 273 556 312 784 81 88 -89 148 -232 148 -352 0 -71 96 -103 140
-47 20 24 21 35 16 100 -15 165 -78 296 -201 419 -65 64 -100 90 -166 121
-140 68 -294 87 -439 56z"
                />
                <path
                    d="M3295 4784 c-209 -44 -401 -194 -495 -389 -51 -104 -72 -197 -71
-316 0 -120 21 -211 71 -314 73 -151 185 -261 343 -335 339 -161 749 -27 931
304 66 120 81 184 81 346 0 126 -3 154 -24 215 -47 142 -127 257 -236 344
-170 135 -391 188 -600 145z m274 -159 c199 -47 366 -208 416 -400 19 -76 19
-211 -1 -289 -50 -196 -222 -359 -423 -402 -284 -60 -564 106 -652 386 -28 89
-28 230 0 320 89 282 378 451 660 385z"
                />
                <path
                    d="M3700 4343 c-8 -3 -90 -80 -182 -171 l-167 -166 -80 77 c-87 85 -111
93 -157 54 -19 -17 -27 -33 -27 -56 0 -28 15 -48 113 -146 62 -63 124 -116
137 -120 13 -3 36 1 51 9 15 8 114 102 220 208 167 169 192 198 192 225 0 45
-9 62 -41 78 -30 16 -35 17 -59 8z"
                />
                <path
                    d="M1695 4453 c-97 -40 -164 -108 -203 -205 -15 -39 -17 -116 -20 -845
l-3 -803 -97 0 c-169 0 -285 -48 -352 -145 -62 -90 -62 -88 -58 -576 4 -425 5
-447 26 -517 65 -214 188 -386 365 -509 110 -78 111 -81 115 -305 4 -188 4
-188 29 -208 34 -27 66 -25 100 4 l28 24 0 189 c0 269 -15 302 -190 434 -109
81 -180 164 -235 274 -76 151 -80 183 -80 642 0 442 -1 435 60 486 42 36 89
47 198 47 l92 0 0 -284 c0 -173 4 -295 10 -312 21 -55 77 -70 123 -33 l27 20
2 1172 c3 1130 4 1173 22 1210 49 100 189 127 273 54 66 -58 63 -17 63 -877 0
-666 2 -785 15 -809 24 -48 81 -56 120 -16 25 24 25 24 25 242 0 191 3 223 19
258 33 72 86 105 167 105 52 0 88 -16 126 -57 44 -46 48 -71 48 -304 l0 -220
26 -24 c32 -30 73 -32 105 -6 23 19 24 25 29 193 5 173 5 175 34 212 41 55 82
76 144 76 58 0 95 -15 129 -52 44 -47 53 -88 53 -248 0 -147 1 -152 25 -175
14 -15 35 -25 52 -25 56 1 83 42 83 127 0 70 21 115 72 156 78 62 198 41 255
-44 l28 -43 0 -620 c0 -618 0 -621 -23 -701 -57 -200 -145 -316 -352 -468 -51
-37 -105 -111 -120 -165 -5 -20 -10 -122 -10 -225 0 -186 0 -188 25 -212 31
-32 66 -32 102 -1 l28 24 5 195 c6 224 -2 205 115 292 187 140 309 318 367
536 21 81 22 104 25 696 5 686 4 692 -63 790 -90 132 -268 179 -416 111 l-56
-26 -17 44 c-22 57 -96 133 -160 164 -42 21 -65 25 -145 25 -88 0 -99 -2 -151
-31 l-57 -31 -33 51 c-69 103 -172 152 -303 144 -45 -3 -86 -13 -113 -26 l-42
-22 -3 472 -3 473 -28 56 c-31 63 -93 126 -159 160 -58 31 -204 37 -263 12z"
                />
            </g>
        </svg>
    );
}
